export enum EsnSubscriptionStatus {
  Unregistered = "Unregistered",
  Registered = "Registered",
  Canceled = "Canceled",
  PendingRenewal = "Pending Renewal",
  ExpiringSoon = "Expiring Soon",
  Expired = "Expired",
}
